export const MyPoisTypeEnum = Object.freeze({
    label: "label",
    saved: "saved",
})